import { createSlice } from "@reduxjs/toolkit";

// --- sessionStorage helpers ---
const loadFromsessionStorage = () => {
  try {
    const serialized = sessionStorage.getItem("pages");
    return serialized ? JSON.parse(serialized) : { states: {} };
  } catch (e) {
    console.error("Failed to load pages from sessionStorage", e);
    return { states: {} };
  }
};

const saveTosessionStorage = (state) => {
  try {
    sessionStorage.setItem("pages", JSON.stringify(state));
  } catch (e) {
    console.error("Failed to save pages to sessionStorage", e);
  }
};

const pageSlice = createSlice({
  name: "pages",
  initialState: loadFromsessionStorage(),
  reducers: {
    savePageState: (state, action) => {
      const { path, pageState } = action.payload;
      state.states[path] = {
        ...(state.states[path] || {}),
        ...pageState,
      };
      saveTosessionStorage(state); 
    },
    removePageState: (state, action) => {
      delete state.states[action.payload];
      saveTosessionStorage(state);
    },
    resetCurrentPage: (state, action) => {
      state.states[action.payload] = {};
      saveTosessionStorage(state);
    },
  },
});

export const { savePageState, removePageState, resetCurrentPage } = pageSlice.actions;
export default pageSlice.reducer;
